import { createMuiTheme } from "@material-ui/core/styles";
import { red } from "@material-ui/core/colors";

const etgsTheme = createMuiTheme({
  typography: {
    fontFamily: "Verdana, Proxima Nova, sans-serif"
  },
  palette: {
    primary: {
      main: "#1565c0"
    },
    secondary: {
      main: "#2196f3"
    },
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  overrides:{
    MuiButton:{
      label:{
        fontWeight:'bold'
      }
    }
  }
});

export default etgsTheme;
